import * as types from 'constants/ActionTypes.js';
import { ROOT_URL } from 'constants/Config.js';

import axios from 'axios';

export function loadCalendar(data) {
  const { building_id, type } = data;
  return async dispatch => {
    dispatch({ type: types.LOAD_CALENDAR, meta: { loader: true } });
    try {
      const response = await axios.post(`${ROOT_URL}/record/calendar`,
        {
          building_id,
          type
        });
      if (response.status === 200) {
        dispatch({ type: types.LOAD_CALENDAR_SUCCESS, payload: response.data });
      }
      return response.data;
    } catch (error) {
      dispatch({ type: types.LOAD_CALENDAR_ERROR, payload: error });
      throw error;
    }
  };
}

export function loadAppointmentStatuses() {
  return async dispatch => {
    dispatch({ type: types.LOAD_APPOINTMENT_STATUSES, meta: { loader: true } });
    try {
      const params = {
        status: JSON.stringify([0, 1, 2, 3])
      };
      const response = await axios.get(`${ROOT_URL}/record/status`, {
        params,
        paramsSerializer: (params) =>
           new URLSearchParams(params).toString()
      });
      if (response.status === 200) {
        dispatch({ type: types.LOAD_APPOINTMENT_STATUSES_SUCCESS, payload: response.data });
      }
      return response.data;
    } catch (error) {
      dispatch({ type: types.LOAD_APPOINTMENT_STATUSES_ERROR, payload: error });
      throw error;
    }
  };
}

export function createAppointment(data) {
  const {
    buildingId,
    type,
    dateTimeFrom,
    firstNameClient,
    phoneClient,
    comment
  } = data;
  return async dispatch => {
    dispatch({ type: types.LOAD_CREATE_APPOINTMENT, meta: { loader: true } });
    try {
      const response = await axios.post(`${ROOT_URL}/record/make`,
        {
          buildingId,
          type,
          dateTimeFrom,
          firstNameClient,
          phoneClient,
          comment
        });
      if (response.status === 200) {
        dispatch({ type: types.LOAD_CREATE_APPOINTMENT_SUCCESS, payload: response.data });
      }
      return response.data;
    } catch (error) {
      dispatch({ type: types.LOAD_CREATE_APPOINTMENT_ERROR, payload: error });
      throw error;
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/appointment.js